import React, { useState } from "react";
import ImagePreviewModel from "../models/ImagePreviewModel";

interface MediaListingProp {
    BaseUrl: string
    mediaUrl: string
}
const MediaListing: React.FC<MediaListingProp> = ({ BaseUrl, mediaUrl }) => {
    const [showPreview, setShowPreview] = useState(false);
    const defaultImageUrl = "/assets/images/No_Image_Available.jpg";
    const [url, setUrl] = useState(`${BaseUrl}/${mediaUrl}`);
    const handleImageError = (fallbackUrl: string) => {
        setUrl(fallbackUrl);
    };

    return (
        <div>
            <div className="group" >
                <div className="relative overflow-hidden rounded-lg border border-light-20">
                    <div
                        onClick={() => setShowPreview(true)}
                        className="relative w-full md:h-60 h-56 transition-all group-hover:scale-110 duration-300">
                        <img
                            src={`${url}`}
                            alt=""
                            onError={() => handleImageError(defaultImageUrl)}
                            className="object-cover w-full h-full inset-0"
                        />
                    </div>
                </div>
            </div>
            {
                showPreview && (
                    <ImagePreviewModel
                        show={showPreview}
                        imageUrl={url}
                        onClose={() => setShowPreview(false)}
                    />
                )
            }
        </div>
    )
}

export default MediaListing;